import { RegionTypeGeneratedEntity } from "./generated/RegionTypeGeneratedEntity";

export abstract class RegionTypeEntity extends RegionTypeGeneratedEntity {
    public get nameComputed(): string {
        const localizer = this.entityContext.localizationService;

        if (this.nameSystem && localizer.isLocalized(this.nameSystem)) {
            return String(localizer.getFormatted(this.nameSystem));
        }

        return this.name?.length > 0 ? this.name : (this.nameSystem ?? "");
    }
}
